<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">

      <div class="grid form-group">
        <div class="col-12 md:col-5 lg:col-5  md:col-offset-1 lg:col-offset-1">
          <div class="div-form">
            <label>{{'LBL_CODIGO' | translate}}:</label>
            <label class="falso-combo-texto">{{ procesoProductivo.codigo }}</label>
          </div>
        </div>

        <div class="col-12 md:col-5 lg:col-5">
          <div class="div-form">
            <label>{{'PROCESOPRODUCTIVO.LBL_VARIABLESINCID' | translate}}:</label>
            <label class="falso-combo-texto">{{ procesoProductivo.nombre }}</label>
          </div>
        </div>

        <div class="grid form-group">
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <p-checkbox [(ngModel)]="procesoProductivo.indicadorEstructuraAgro" binary="true" disabled="true"></p-checkbox>
              <label class="pl-2">{{'PROCESOPRODUCTIVO.LBL_ESTRUCAGRIC' | translate}}</label>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <p-checkbox [(ngModel)]="procesoProductivo.indicadorEstructuraPecuaria" binary="true" disabled="true"></p-checkbox>
              <label class="pl-2">{{'PROCESOPRODUCTIVO.LBL_ESTRUCPECUR' | translate}}</label>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div class="div-form">
              <p-checkbox [(ngModel)]="procesoProductivo.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="lisVariableIncidencia" selectionMode="single" dataKey="idVariableIncidencia"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="table-break">{{row.codigo}}</td>
            <td class="table-break">{{row.variableIncidencia}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <div>
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar(false)"
              pButton></button>
    </div>
  </div>
</div>
